/* src/app/components/userandgroup/bulk-upload/bulk-upload.component.scss */
.bulk-upload-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 1rem;
}
.bulk-upload-overlay .bulk-upload-panel {
  background: #fff;
  width: 100%;
  max-width: 700px;
  max-height: 90vh;
  overflow-y: auto;
  border-radius: 1rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  animation: fadeIn 0.3s ease;
}
@media (max-width: 600px) {
  .bulk-upload-overlay .bulk-upload-panel {
    border-radius: 0.75rem;
    max-width: 100%;
  }
}
.bulk-upload-overlay .bulk-upload-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #eee;
  background: #f9fafb;
  order: 0;
}
.bulk-upload-overlay .bulk-upload-header .title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0;
}
.bulk-upload-overlay .bulk-upload-header .close-btn {
  border: none;
  background: transparent;
  font-size: 1.2rem;
  cursor: pointer;
  color: #666;
  transition: color 0.2s;
}
.bulk-upload-overlay .bulk-upload-header .close-btn:hover {
  color: #000;
}
.bulk-upload-overlay .bulk-upload-body {
  padding: 1.5rem;
}
.bulk-upload-overlay .bulk-upload-body .upload-info .desc {
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
  color: #555;
}
.bulk-upload-overlay .bulk-upload-body .upload-info .guidelines {
  margin: 0;
  padding-left: 1.2rem;
  color: #666;
  font-size: 0.9rem;
}
.bulk-upload-overlay .bulk-upload-body .upload-info .guidelines li {
  margin-bottom: 0.4rem;
}
.bulk-upload-overlay .bulk-upload-body .upload-info .guidelines .link {
  color: #253b80 !important;
  cursor: pointer;
  text-decoration: underline;
}
.bulk-upload-overlay .bulk-upload-body .upload-info .guidelines .link:hover {
  color: #0056b3;
}
.bulk-upload-overlay .bulk-upload-body .dropzone {
  margin-top: 1.5rem;
  border: 2px dashed #ccc;
  border-radius: 0.75rem;
  text-align: center;
  padding: 2rem;
  transition: all 0.3s ease;
  cursor: pointer;
}
.bulk-upload-overlay .bulk-upload-body .dropzone.dragging {
  background: #f0f8ff;
  border-color: #253b80;
}
.bulk-upload-overlay .bulk-upload-body .dropzone input[type=file] {
  display: none;
}
.bulk-upload-overlay .bulk-upload-body .dropzone .dropzone-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.4rem;
  color: #444;
}
.bulk-upload-overlay .bulk-upload-body .dropzone .dropzone-label .icon {
  font-size: 2rem;
  color: #253b80;
}
.bulk-upload-overlay .bulk-upload-body .dropzone .dropzone-label .text {
  font-size: 0.95rem;
}
.bulk-upload-overlay .bulk-upload-body .dropzone .dropzone-label small {
  color: #777;
  font-size: 0.85rem;
}
.bulk-upload-overlay .bulk-upload-body .files-section {
  margin-top: 1.5rem;
}
.bulk-upload-overlay .bulk-upload-body .files-section .files-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
}
.bulk-upload-overlay .bulk-upload-body .files-section .files-header .sub-title {
  font-weight: 500;
  font-size: 1rem;
}
.bulk-upload-overlay .bulk-upload-body .files-section .files-header .clear-btn {
  background: transparent;
  border: none;
  color: #dc3545;
  cursor: pointer;
  font-weight: 500;
}
.bulk-upload-overlay .bulk-upload-body .files-section .files-header .clear-btn:hover {
  text-decoration: underline;
}
.bulk-upload-overlay .bulk-upload-body .files-section .file-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.bulk-upload-overlay .bulk-upload-body .files-section .file-list li {
  background: #f9fafc;
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
  margin-bottom: 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.bulk-upload-overlay .bulk-upload-body .files-section .file-list li.error {
  border-left: 4px solid #dc3545;
}
.bulk-upload-overlay .bulk-upload-body .files-section .file-list li .file-info {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.bulk-upload-overlay .bulk-upload-body .files-section .file-list li .file-info .meta .file-name {
  font-weight: 500;
  max-width: 58em;
  border: none;
}
.bulk-upload-overlay .bulk-upload-body .files-section .file-list li .file-info .meta .file-size {
  color: #777;
  font-size: 0.85rem;
  padding: 0em 1.2em;
}
.bulk-upload-overlay .bulk-upload-body .files-section .file-list li .file-info .meta .error-msg {
  color: #dc3545;
  font-size: 0.8rem;
}
.bulk-upload-overlay .bulk-upload-body .files-section .file-list li .file-info .remove-file-btn {
  border: none;
  background: transparent;
  color: #888;
  cursor: pointer;
  font-size: 1.1rem;
}
.bulk-upload-overlay .bulk-upload-body .files-section .file-list li .file-info .remove-file-btn:hover {
  color: #dc3545;
}
.bulk-upload-overlay .preview-section {
  padding: 1.5rem;
}
.bulk-upload-overlay .preview-section .info-banner {
  background: #e9f6ff;
  border-left: 4px solid #253b80;
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  font-size: 0.9rem;
  color: #004b9a;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.bulk-upload-overlay .preview-section .table-wrapper {
  overflow-x: auto;
}
.bulk-upload-overlay .preview-section .table-wrapper .data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}
.bulk-upload-overlay .preview-section .table-wrapper .data-table th,
.bulk-upload-overlay .preview-section .table-wrapper .data-table td {
  padding: 0.75rem;
  border-bottom: 1px solid #e6e6e6;
  text-align: left;
}
.bulk-upload-overlay .preview-section .table-wrapper .data-table th {
  background: #f1f3f6;
  font-weight: 600;
}
.bulk-upload-overlay .preview-section .table-wrapper .data-table tr:hover {
  background: #fafafa;
}
.bulk-upload-overlay .preview-section .table-wrapper .data-table .icon-btn.danger {
  color: #dc3545;
  background: transparent;
  border: none;
  cursor: pointer;
}
.bulk-upload-overlay .preview-section .table-wrapper .data-table .icon-btn.danger:hover {
  color: #b52b3a;
}
.bulk-upload-overlay .bulk-upload-footer {
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  border-top: 1px solid #eee;
  background: #f9fafb;
}
.bulk-upload-overlay .bulk-upload-footer .btn {
  padding: 0.6rem 1.2rem;
  border-radius: 0.5rem;
  border: none;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
}
.bulk-upload-overlay .bulk-upload-footer .btn.btn-primary {
  background: #253b80;
  color: #fff;
}
.bulk-upload-overlay .bulk-upload-footer .btn.btn-primary:hover {
  background: #005ecb;
}
.bulk-upload-overlay .bulk-upload-footer .btn.btn-primary.loading {
  opacity: 0.6;
  cursor: not-allowed;
}
.bulk-upload-overlay .bulk-upload-footer .btn.btn-secondary {
  background: #e4e6eb;
  color: #333;
}
.bulk-upload-overlay .bulk-upload-footer .btn.btn-secondary:hover {
  background: #d6d8dc;
}
.bulk-upload-overlay .bulk-upload-footer .btn.btn-outline {
  background: transparent;
  border: 1px solid #253b80;
  color: #253b80;
}
.bulk-upload-overlay .bulk-upload-footer .btn.btn-outline:hover {
  background: #253b80;
  color: #fff;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.96);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
/*# sourceMappingURL=bulk-upload.component.css.map */
